
import { useState } from 'react';

const reviews = [
  {
    id: 1,
    name: 'Anh Minh',
    location: 'Bình Dương',
    avatar: 'https://public.readdy.ai/ai/img_res/c8e138d5f08696bc3ad8f0eaff6b11f2.jpg',
    content: 'Công ty thu mua rất nhanh, giá cao hơn thị trường. Nhân viên làm việc chuyên nghiệp, thanh toán ngay trong ngày. Tôi rất hài lòng và sẽ tiếp tục hợp tác lâu dài.',
    stars: 5,
    tag: 'Sắt thép',
  },
  {
    id: 2,
    name: 'Chị Lan',
    location: 'TP.HCM',
    avatar: 'https://readdy.ai/api/search-image?query=real%20vietnamese%20woman%2040s%20friendly%20smile%20casual%20clothes%20natural%20daylight%20candid%20street%20portrait%20photo%20realistic%20not%20AI%20generated&width=200&height=200&seq=avatar-lan-002&orientation=squarish',
    content: 'Tôi đã hợp tác nhiều lần, luôn đúng hẹn và minh bạch. Giá thu mua ổn định, không ép giá. Rất đáng tin cậy, tôi đã giới thiệu cho nhiều bạn bè cùng sử dụng.',
    stars: 5,
    tag: 'Nhôm & Đồng',
  },
  {
    id: 3,
    name: 'Anh Hùng',
    location: 'Đồng Nai',
    avatar: 'https://readdy.ai/api/search-image?query=real%20vietnamese%20man%2035%20years%20old%20worker%20casual%20t-shirt%20smiling%20natural%20light%20outdoor%20candid%20portrait%20photo%20realistic%20not%20AI%20generated&width=200&height=200&seq=avatar-hung-003&orientation=squarish',
    content: 'Dịch vụ tốt, hỗ trợ nhiệt tình, báo giá rõ ràng không có phí ẩn. Nhân viên đến đúng giờ, cân đo chính xác. Sẽ gọi lại lần sau khi có thêm phế liệu.',
    stars: 5,
    tag: 'Máy móc cũ',
  },
  {
    id: 4,
    name: 'Anh Tuấn',
    location: 'Long An',
    avatar: 'https://readdy.ai/api/search-image?query=real%20vietnamese%20man%2045%20years%20old%20business%20owner%20casual%20shirt%20confident%20smile%20natural%20lighting%20portrait%20photo%20realistic%20not%20AI%20generated&width=200&height=200&seq=avatar-tuan-004&orientation=squarish',
    content: 'Xưởng tôi thanh lý máy móc cũ, Nam Phát định giá nhanh và trả tiền mặt ngay tại chỗ. Quy trình gọn gàng, không mất nhiều thời gian. Rất chuyên nghiệp!',
    stars: 5,
    tag: 'Nhà xưởng thanh lý',
  },
  {
    id: 5,
    name: 'Chị Hoa',
    location: 'Bình Phước',
    avatar: 'https://readdy.ai/api/search-image?query=real%20vietnamese%20woman%2050s%20market%20vendor%20friendly%20face%20natural%20smile%20outdoor%20daylight%20candid%20portrait%20photo%20realistic%20not%20AI%20generated&width=200&height=200&seq=avatar-hoa-005&orientation=squarish',
    content: 'Lần đầu gọi là được tư vấn ngay, nhân viên đến trong vòng 1 tiếng. Giá inox cao hơn chỗ khác tôi từng bán. Thanh toán chuyển khoản nhanh, rất tiện lợi.',
    stars: 5,
    tag: 'Inox',
  },
];

export default function CustomerReviews() {
  const [current, setCurrent] = useState(0);
  const visible = 3;
  const total = reviews.length;

  const prev = () => setCurrent((c) => (c - 1 + total) % total);
  const next = () => setCurrent((c) => (c + 1) % total);

  const getVisible = () => {
    const items = [];
    for (let i = 0; i < visible; i++) {
      items.push(reviews[(current + i) % total]);
    }
    return items;
  };

  return (
    <section id="reviews" className="py-24 bg-gradient-to-br from-amber-50 via-white to-teal-50">
      <div className="max-w-7xl mx-auto px-6">
        {/* Header */}
        <div className="text-center mb-4">
          <span className="text-teal-600 text-sm font-bold uppercase tracking-widest">Đánh Giá Thực Tế</span>
        </div>
        <div className="text-center mb-3">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 leading-tight">
            Ý Kiến Khách Hàng
          </h2>
        </div>
        <div className="text-center mb-12">
          <p className="text-gray-500 text-base max-w-xl mx-auto">
            Khách hàng nói gì về chúng tôi — những phản hồi thực tế từ hàng nghìn lượt hợp tác trên toàn khu vực.
          </p>
        </div>

        {/* Overall Rating Bar */}
        <div className="flex items-center justify-center gap-6 mb-12">
          <div className="flex items-center gap-2 bg-white border border-amber-200 rounded-full px-6 py-3 shadow-sm">
            <div className="flex gap-0.5">
              {[1,2,3,4,5].map((s) => (
                <div key={s} className="w-5 h-5 flex items-center justify-center">
                  <i className="ri-star-fill text-amber-400 text-lg"></i>
                </div>
              ))}
            </div>
            <span className="text-gray-900 font-bold text-lg ml-1">5.0</span>
            <span className="text-gray-400 text-sm">/ 5.0</span>
            <span className="text-gray-400 text-sm ml-2">· 5000+ đánh giá</span>
          </div>
        </div>

        {/* Cards */}
        <div className="grid md:grid-cols-3 gap-6 mb-10">
          {getVisible().map((review) => (
            <div
              key={review.id}
              className="bg-white rounded-2xl p-7 shadow-md hover:shadow-xl transition-all duration-300 flex flex-col gap-4 border border-gray-100"
            >
              {/* Stars */}
              <div className="flex gap-0.5">
                {[1,2,3,4,5].map((s) => (
                  <div key={s} className="w-4 h-4 flex items-center justify-center">
                    <i className="ri-star-fill text-amber-400 text-base"></i>
                  </div>
                ))}
              </div>

              {/* Content */}
              <p className="text-gray-700 text-sm leading-relaxed flex-1">
                "{review.content}"
              </p>

              {/* Tag */}
              <div>
                <span className="inline-block bg-teal-50 text-teal-700 text-xs font-semibold px-3 py-1 rounded-full border border-teal-100">
                  {review.tag}
                </span>
              </div>

              {/* Author */}
              <div className="flex items-center gap-3 pt-2 border-t border-gray-100">
                <div className="w-11 h-11 rounded-full overflow-hidden flex-shrink-0 border-2 border-amber-200">
                  <img
                    src={review.avatar}
                    alt={review.name}
                    className="w-full h-full object-cover object-top"
                  />
                </div>
                <div>
                  <div className="text-gray-900 font-bold text-sm">{review.name}</div>
                  <div className="text-gray-400 text-xs flex items-center gap-1">
                    <div className="w-3 h-3 flex items-center justify-center">
                      <i className="ri-map-pin-2-fill text-teal-500 text-xs"></i>
                    </div>
                    {review.location}
                  </div>
                </div>
                <div className="ml-auto">
                  <div className="w-8 h-8 flex items-center justify-center bg-amber-50 rounded-full">
                    <i className="ri-double-quotes-r text-amber-400 text-base"></i>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Navigation */}
        <div className="flex items-center justify-center gap-4 mb-14">
          <button
            onClick={prev}
            className="w-11 h-11 bg-white border border-gray-200 rounded-full flex items-center justify-center hover:bg-gray-50 transition-colors cursor-pointer shadow-sm"
          >
            <div className="w-11 h-11 flex items-center justify-center">
              <i className="ri-arrow-left-s-line text-gray-600 text-xl"></i>
            </div>
          </button>
          <div className="flex gap-2">
            {reviews.map((_, i) => (
              <button
                key={i}
                onClick={() => setCurrent(i)}
                className={`h-2 rounded-full transition-all cursor-pointer ${i === current ? 'w-6 bg-teal-500' : 'w-2 bg-gray-300'}`}
              />
            ))}
          </div>
          <button
            onClick={next}
            className="w-11 h-11 bg-gray-900 rounded-full flex items-center justify-center hover:bg-gray-800 transition-colors cursor-pointer shadow-sm"
          >
            <div className="w-11 h-11 flex items-center justify-center">
              <i className="ri-arrow-right-s-line text-white text-xl"></i>
            </div>
          </button>
        </div>

        {/* CTA */}
        <div className="text-center">
          <div className="inline-block bg-gradient-to-r from-teal-600 to-teal-500 rounded-2xl px-10 py-8 shadow-xl">
            <p className="text-white/80 text-sm mb-2 font-medium">Bạn có phế liệu cần bán?</p>
            <h3 className="text-white text-2xl font-bold mb-5">
              Liên hệ ngay để được báo giá tốt nhất
            </h3>
            <div className="flex flex-col sm:flex-row gap-3 justify-center">
              <a
                href="tel:0968947136"
                className="inline-flex items-center justify-center gap-2 bg-white text-teal-700 font-bold px-7 py-3 rounded-full hover:bg-amber-50 transition-colors whitespace-nowrap text-sm shadow"
              >
                <div className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-phone-fill text-teal-600 text-base"></i>
                </div>
                Gọi Ngay: 0968 947 136
              </a>
              <a
                href="#contact"
                className="inline-flex items-center justify-center gap-2 bg-amber-400 text-gray-900 font-bold px-7 py-3 rounded-full hover:bg-amber-300 transition-colors whitespace-nowrap text-sm shadow"
              >
                <div className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-message-3-line text-gray-900 text-base"></i>
                </div>
                Gửi Yêu Cầu Báo Giá
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
